import React, { Fragment, useState } from 'react';
import Container from './Container';
import Button from './Button';
import { Dialog, Transition } from '@headlessui/react';
import CharityWallet from './CharityWallet';

function CharityHero() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Container>
      <div className='pt-32 pb-32'>
        <div className='max-w-[250px] md:max-w-[500px] mx-auto'>
          <img src='/charity-logo.png' alt='The Gekofam & Friends Charity Wallet' />
        </div>

        <div className='flex flex-col max-w-xl mx-auto space-y-5 text-center'>
          <h1 className='mt-6 text-3xl font-extrabold tracking-tight text-center lg:leading-tight sm:text-5xl md:text-6xl lg:text-5xl'>
            The Gekofam & Friends <br />
            <span className='text-primary-500'>Charity Wallet</span>
          </h1>

          <p className='text-lg'>
            The Gekofam & Friends Charity Wallet was created because we believe in giving back! All Algo, NFTs, and Time is 100% donated.
          </p>

          <div>
            <Button onClick={() => setModalOpen(true)}>Donate Now</Button>
          </div>
        </div>
      </div>

      <Transition.Root show={modalOpen} as={Fragment}>
        <Dialog as='div' className='relative z-50' onClose={() => setModalOpen(false)}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 z-20 transition-opacity bg-black bg-opacity-75' />
          </Transition.Child>

          <div className='fixed inset-0 z-20 overflow-y-auto'>
            <div className='flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                enterTo='opacity-100 translate-y-0 sm:scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 translate-y-0 sm:scale-100'
                leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              >
                <Dialog.Panel
                  className={`relative overflow-hidden text-left transition-all transform rounded-lg shadow-xl bg-modal-bg sm:my-8 sm:max-w-xl sm:w-full`}
                >
                  <CharityWallet />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </Container>
  );
}

export default CharityHero;
